<ng-container *transloco="let t">
<ng-template #myInfo>
  <form #myInfoForm="ngForm" novalidate id="myInfoForm" name="myInfoForm">

    @if (inEditMode) {
      <my-info-step-editor [step]="step"
        [(allowBorrowerEnterCoBorrowerPersonalInformation)]="allowBorrowerEnterCoBorrowerPersonalInformation"
        [canConfigureCoBorrowerPersonalInfo]="canConfigureCoBorrowerPersonalInfo"></my-info-step-editor>
    }

    <div class="fs-4 fw-bolder text-dark">{{ t('wizard.myInfo.title') }}</div>
    <div class="separator separator-dashed my-3"></div>
    <div class="row g-9 mb-8">
      @if (!isHidden('borrower.firstName')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.firstName')}">{{getLabel('borrower.firstName', t('wizard.myInfo.firstName'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" required [(ngModel)]="borrower.firstName" #firstName="ngModel"
              [placeholder]="t('wizard.myInfo.firstName')" name="firstName"
              [ngClass]="{'is-invalid' : firstName && firstName.touched && firstName.invalid}"
              [required]="isRequired('borrower.firstName')"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.middleName')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.middleName')}">{{getLabel('borrower.middleName', t('wizard.myInfo.middleName'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.middleName"
              [required]="isRequired('borrower.middleName')" placeholder="" name="middleName"
              [attr.maxlength]="step.restrictMiddleNameToSingleCharacter ? 1 : 50"
              [ngClass]="{'is-invalid' : middleName && middleName.touched && middleName.invalid}" #middleName="ngModel" />
            <!-- <div class="invalid-feedback">Please enter a middle name.</div> -->
          </div>
        </div>
      }
      @if (!isHidden('borrower.lastName')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.lastName')}">{{getLabel('borrower.lastName', t('wizard.myInfo.lastName'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" [placeholder]="t('wizard.myInfo.lastName')"
              [(ngModel)]="borrower.lastName" #lastName="ngModel" name="lastName"
              [ngClass]="{'is-invalid' : lastName && lastName.touched && lastName.invalid}"
              [required]="isRequired('borrower.lastName')"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.nameSuffix')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.nameSuffix')}">{{getLabel('borrower.nameSuffix', t('wizard.myInfo.suffix'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="suffix" #suffix="ngModel" [(ngModel)]="borrower.nameSuffix"
          [ngClass]="{'is-invalid' : suffix && suffix.touched && suffix.invalid}"
          [required]="isRequired('borrower.nameSuffix')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            <option value="Jr">Jr</option>
            <option value="Sr">Sr</option>
            <option value="I">I</option>
            <option value="II">II</option>
            <option value="III">III</option>
          </select>
        </div>
      }
    </div>
    <div class="row g-9 mb-8">
      @if (!isHidden('borrower.mobilePhone')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.mobilePhone')}">{{getLabel('borrower.mobilePhone', t('wizard.myInfo.phoneNumber'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid"  placeholder="" mask='(000) 000-0000'
              #phoneNumber="ngModel"
              [(ngModel)]="borrower.mobilePhone" name="phoneNumber" ngControl="phoneNumber" id="phoneNumber"
              [ngClass]="{'is-invalid' : phoneNumber && phoneNumber.touched && phoneNumber.invalid}"
              [required]="isRequired('borrower.mobilePhone')"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.homePhone')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.homePhone')}">{{getLabel('borrower.homePhone', t('wizard.borrowerInfo.homePhone'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" placeholder="" mask='(000) 000-0000'
              #homePhone="ngModel"
              [(ngModel)]="borrower.homePhone" name="homePhone" ngControl="homePhone" id="homePhone"
              [ngClass]="{'is-invalid' : homePhone && homePhone.touched && homePhone.invalid}"
              [required]="isRequired('borrower.homePhone')"/>
          </div>
        </div>
        <!-- Flex-break: when Home Phone is visible the row has 5 col-md-3 cells, so the
             5th wraps and lands alone. This break keeps phone fields paired on line 1
             and Birth/SSN/Citizenship grouped on line 2. -->
        <div class="w-100 d-none d-md-block"></div>
      }
      @if (!isHidden('borrower.dateOfBirth')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.dateOfBirth')}">{{getLabel('borrower.dateOfBirth', t('wizard.myInfo.birthDate'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true"
              [specialCharacters]="[ '/' ]" inputmode="numeric" [dropSpecialCharacters]="false" datePicker #birthDate="ngModel"
              [(ngModel)]="borrower.dateOfBirth" placeholder="" name="birthDate" ngControl="birthDate" id="birthDate"
              [ngClass]="{'is-invalid' : birthDate && birthDate.touched && birthDate.invalid}"
              [required]="isRequired('borrower.dateOfBirth')"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.socialSecNum')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.socialSecNum')}">{{getLabel('borrower.socialSecNum', t('wizard.myInfo.ssn'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" matInput mask="000-00-0000" [showMaskTyped]="true"
              [(ngModel)]="borrower.socialSecNum" #socialSecNum="ngModel" [specialCharacters]="[ '-' ]"
              [dropSpecialCharacters]="false" [patterns]="ssnPattern" [placeholder]="t('wizard.myInfo.ssn')" name="ssn" id="ssn"
              [required]="isRequired('borrower.socialSecNum')" [ngClass]="{'is-invalid' : socialSecNum && socialSecNum.touched && socialSecNum.invalid}" />
          </div>
        </div>
      }
      @if (!isHidden('borrower.declarations.residenceStatus')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.declarations.residenceStatus')}">{{getLabel('borrower.declarations.residenceStatus', t('wizard.myInfo.citizenship'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="citizenship"
            [(ngModel)]="borrower.declarations!.residenceStatus" #residenceStatus="ngModel"
            [ngClass]="{'is-invalid' : residenceStatus && residenceStatus.touched && residenceStatus.invalid}"
            [required]="isRequired('borrower.declarations.residenceStatus')">
            <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
            <option value="USCitizen">{{ t('wizard.myInfo.usCitizen') }}</option>
            <option value="PermanentResident">{{ t('wizard.myInfo.permanentResident') }}</option>
            <option value="NonPermanentResidentAlien">{{ t('wizard.myInfo.nonPermanentResidentAlien') }}</option>
          </select>
        </div>
      }
    </div>
    <div class="row g-9 mb-8">
      @if (!isHidden('borrower.maritalStatus')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.maritalStatus')}">{{getLabel('borrower.maritalStatus', t('wizard.myInfo.maritalStatus'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="maritalStatus"
            [(ngModel)]="borrower.maritalStatus" (ngModelChange)="onMaritalStatusChanged()" #maritalStatus="ngModel"
            [ngClass]="{'is-invalid' : maritalStatus && maritalStatus.touched && maritalStatus.invalid}"
            [required]="isRequired('borrower.maritalStatus')">
            <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
            <option value="Single">{{ t('wizard.myInfo.single') }}</option>
            <option value="Married">{{ t('wizard.myInfo.married') }}</option>
            <option value="Separated">{{ t('wizard.myInfo.separated') }}</option>
            <option value="Other">{{ t('wizard.myInfo.other') }}</option>
          </select>
        </div>
      }

      <!-- WI 24451 — unmarried-partner (URLA Basic Details) conditional group: shown when Single or Other (OPE-1). -->
      @if (showUnmarriedPartnerGate) {
        <div class="col-md-6 fv-row d-flex align-items-center">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" name="unmarriedAddendum"
              [(ngModel)]="unmarriedAddendum" (ngModelChange)="onUnmarriedAddendumChanged()" id="unmarriedAddendumPrimary"/>
            <label class="form-check-label ms-3" for="unmarriedAddendumPrimary">
              {{getLabel('borrower.unmarriedAddendum', t('wizard.myInfo.unmarriedPartner'))}}
            </label>
          </div>
        </div>
      }
      @if (showUnmarriedPartnerDetails && !isHidden('borrower.domesticRelationshipType')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.domesticRelationshipType')}">{{getLabel('borrower.domesticRelationshipType', t('wizard.myInfo.relationshipType'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="domesticRelationshipType"
            [(ngModel)]="borrower.domesticRelationshipType" (ngModelChange)="onDomesticRelationshipTypeChanged()" #domesticRelationshipType="ngModel"
            [ngClass]="{'is-invalid' : domesticRelationshipType && domesticRelationshipType.touched && domesticRelationshipType.invalid}"
            [required]="isRequired('borrower.domesticRelationshipType')"
            [attr.data-placeholder]="t('common.selectOne')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (rt of domesticRelationshipTypeOptions; track rt.value) {
              <option [ngValue]="rt.value">{{ t('enums.domesticRelationshipType.' + rt.value) }}</option>
            }
          </select>
        </div>
      }
      @if (showUnmarriedPartnerDetails && borrower.domesticRelationshipType === DomesticRelationshipTypeEnum.Other && !isHidden('borrower.unmarriedRelationshipTypeOther')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.unmarriedRelationshipTypeOther')}">{{getLabel('borrower.unmarriedRelationshipTypeOther', t('wizard.myInfo.specifyRelationshipType'))}}</label>
          <input class="form-control form-control-solid" name="unmarriedRelationshipTypeOther"
            [(ngModel)]="borrower.unmarriedRelationshipTypeOther" #unmarriedRelationshipTypeOther="ngModel"
            [placeholder]="t('wizard.myInfo.specifyRelationshipType')"
            [ngClass]="{'is-invalid' : unmarriedRelationshipTypeOther && unmarriedRelationshipTypeOther.touched && unmarriedRelationshipTypeOther.invalid}"
            [required]="isRequired('borrower.unmarriedRelationshipTypeOther')"/>
        </div>
      }
      @if (showUnmarriedPartnerDetails && !isHidden('borrower.unmarriedRelationshipState')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.unmarriedRelationshipState')}">{{getLabel('borrower.unmarriedRelationshipState', t('wizard.myInfo.relationshipState'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="unmarriedRelationshipState"
            [(ngModel)]="borrower.unmarriedRelationshipState" #unmarriedRelationshipState="ngModel"
            [ngClass]="{'is-invalid' : unmarriedRelationshipState && unmarriedRelationshipState.touched && unmarriedRelationshipState.invalid}"
            [required]="isRequired('borrower.unmarriedRelationshipState')"
            [attr.data-placeholder]="t('common.selectOne')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (st of usStates; track st.value) {
              <option [ngValue]="st.value">{{st.name}}</option>
            }
          </select>
        </div>
      }

      @if (!isHidden('borrower.numberOfDependents')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.numberOfDependents')}">{{getLabel('borrower.numberOfDependents', t('wizard.myInfo.numberOfDependents'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input type="number"
              numeric
              [allowNegative]="false"
              class="form-control form-control-solid numeric-without-arrows"
              value="{{borrower.dependents.length}}"
              name="numberOfDependents"
              [(ngModel)]="noOfDependents"
              (ngModelChange)="onNoOfDependentsChanged()"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.dependentAges')) {
        <div class="col-md-3 fv-row">
          <label class="form-label">{{getLabel('borrower.dependentAges', t('wizard.myInfo.dependentAges'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input type="text" class="form-control form-control-solid dependents-info"
              name="dependentAges"
              [placeholder]="t('wizard.myInfo.none')" name="dependentAges"
              #borrowerDependentAges="ngModel"
              [(ngModel)]="dependentAges"/>
            <span data-bs-toggle="tooltip" data-bs-trigger="hover" class="mx-2" [title]="t('wizard.myInfo.editDependents')">
              <a (click)="onEditDependentsClicked()" class="btn btn-sm btn-light-primary">{{ t('wizard.myInfo.editDependents') }}</a>
            </span>
          </div>
        </div>
      }

      <div class="col-md-3 fv-row">
      </div>
    </div>
    <div class="row g-9 mb-8">
      @if (!isHidden('borrower.languagePreference')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.languagePreference')}">{{getLabel('borrower.languagePreference', t('wizard.myInfo.languagePreference'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="languagePreference"
            [(ngModel)]="borrower.languagePreference"  (ngModelChange)="onLanguagePreferenceChanged()" #languagePreference="ngModel"
            [ngClass]="{'is-invalid' : languagePreference && languagePreference.touched && languagePreference.invalid}"
            [required]="isRequired('borrower.languagePreference')">
            <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
            @for (lang of languagePreferenceOptions; track lang.value) {
              <option [ngValue]="lang.value">{{ t('enums.language.' + lang.value) }}</option>
            }
          </select>
        </div>
      }
      @if (!isHidden('borrower.languagePreferenceOtherDescription') && borrower.languagePreference === 'Other') {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.languagePreferenceOtherDescription')}">{{getLabel('borrower.languagePreferenceOtherDescription', t('wizard.myInfo.specifyLanguage'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid"  [(ngModel)]="borrower.languagePreferenceOtherDescription" #languagePreferenceOtherDescription="ngModel"
              [placeholder]="t('wizard.myInfo.specifyLanguage')" name="languagePreferenceOtherDescription"
              [ngClass]="{'is-invalid' : languagePreferenceOtherDescription && languagePreferenceOtherDescription.touched && languagePreferenceOtherDescription.invalid}"
              [required]="isRequired('borrower.languagePreferenceOtherDescription')"/>
          </div>
        </div>
      }
    </div>

    @if (step.configuresAddressHistory) {
      <div class="row">
        <borrower-address-history
          [borrower]="borrower"
          [fieldsToConfig]="step.addressFieldsConfig"
          [currentAddressLabel]="t('wizard.myInfo.myHomeAddress')">
        </borrower-address-history>
      </div>
    }

    @if (!inCoApplyFlow && step.configuresCoborrowers && wizardFlowService.canManageCoBorrowers) {
      <div class="row">
        <div class="col-sm-4 fs-4 fw-bolder text-dark" style="padding-top: 8px;">{{ t('wizard.myInfo.applyingWithAnyone') }}</div>
        <a class="col-sm-3 btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary mb-8"
          (click)="onAddCoBorrowerClicked()">{{ t('wizard.myInfo.addCoBorrower') }}</a>
        <div class="col-sm-5"></div>
      </div>
    }
    @if (step.configuresCoborrowers) {
      <div class="row">
        @if (coBorrowers.length > 0) {
          <div class="fs-4 fw-bolder text-dark">{{ t('wizard.myInfo.coBorrowers') }}</div>
        }
        @if (coBorrowers.length > 0) {
          <div class="separator separator-dashed my-3"></div>
        }
        @for (coBorrower of coBorrowers; track coBorrower.borrowerId; let i = $index) {
          <div
            class="rounded border p-10 pb-0 mb-6 d-flex align-items-center flex-wrap ribbon ribbon-top ribbon-vertical"
            [ngClass]="{'border-danger' : coBorrowerToDelete === coBorrower}">
            @if (wizardFlowService.canManageCoBorrowers) {
              <div class="ribbon-label bg-white">
                @if (coBorrowerToDelete !== coBorrower) {
                  <i class="bi bi-trash fs-2 text-warning"
                    (click)="onCoBorrowerDeleteClicked(coBorrower)"></i>
                }
                @if (coBorrowerToDelete === coBorrower) {
                  <i class="bi bi-x fs-2 text-danger"
                    (click)="onCoBorrowerDeleteCancelClicked(coBorrower)"></i>
                }
                @if (coBorrowerToDelete === coBorrower) {
                  <i class="bi bi-check fs-2 text-success" style="padding-right: 4px;"
                    (click)="onCoBorrowerDeleteConfirmClicked(coBorrower)"></i>
                }
              </div>
            }
            <borrower-info-mini #borrowerInfo [fieldsToConfig]="step.borrowerFieldsConfig"
                [borrower]="coBorrower" [borrowerSettings]="borrowerSettings"
                [allowBorrowerEnterCoBorrowerPersonalInformation]="effectiveAllowBorrowerEnterCoBorrowerPersonalInformation">
            </borrower-info-mini>
          </div>
        }
      </div>
    }

  </form>
</ng-template>

<wizard-step-template [stepMainTemplate]="myInfo" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
